import { TbHexagonalPyramid } from "react-icons/tb";
import { FaSolarPanel } from "react-icons/fa";
import { HiViewGrid } from "react-icons/hi";
import React from "react";
import { Dropdown } from "semantic-ui-react";
import { useDispatch } from "react-redux";
import { closePVDesign, openPVDesign } from "../redux/pvDesign";
import { setSensorAnalysisState } from "../redux/sensorAnalysis";
import "./ExecutionToolbox.css";
import {
  sensorAnalysisDefaultActiveTab,
  statesNames,
} from "../redux/sensorAnalysisConstants";
import { setIsObjectPlacementMode } from "../redux/objectPlacement";

const ExecutionToolbox = () => {
  const dispatch = useDispatch();

  const handlePVExecution = () => {
    dispatch(openPVDesign());
    dispatch(setSensorAnalysisState(statesNames.EXIT));
    dispatch(setIsObjectPlacementMode(false));
  };

  const handleSensorAnalysis = () => {
    dispatch(setSensorAnalysisState(sensorAnalysisDefaultActiveTab));
    dispatch(closePVDesign());
    dispatch(setIsObjectPlacementMode(false));
  };

  const handleObjectPlacement = () => {
    dispatch(setIsObjectPlacementMode(true));
    dispatch(closePVDesign());
    dispatch(setSensorAnalysisState(statesNames.EXIT));
  };

  return (
    <div className="toolbox-container">
      <Dropdown
        item
        simple
        text="Execution Tools"
        className="drop-down toolbox-btn"
      >
        <Dropdown.Menu className="toolbox-menu">
          <Dropdown.Item onClick={handlePVExecution} className="toolbox-item">
            <FaSolarPanel className="dropdown-icon" />
            PV Positioning
          </Dropdown.Item>
          <Dropdown.Item
            onClick={handleSensorAnalysis}
            className="toolbox-item"
          >
            <HiViewGrid className="dropdown-icon" />
            Sensor Meshing
          </Dropdown.Item>
          <Dropdown.Item
            onClick={handleObjectPlacement}
            className="toolbox-item"
          >
            <TbHexagonalPyramid className="dropdown-icon" />
            Object Placement
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default ExecutionToolbox;
